<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__4_legal')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__4_legal_regulatory')}}</strong></label>
        <div>
          <small>{{$t('medium_grant.diligence__4_legal_regulatory_sub')}}</small>
        </div>
        <div class="mt-3"></div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.isRegulatoryComplain"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.isRegulatoryComplain"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.isRegulatoryComplain" value="false" v-model="GrantForm.revisionModel.diligence.isRegulatoryComplain">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
        <label class="mt-3">{{$t('medium_grant.diligence__4_if_no_please_indicate')}}</label>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.isRegularyComplainText"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-5">
          <p class="white-space-pre">{{$t('medium_grant.diligence__4_legal_note_footer')}}</p>
        </div>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>